import React from 'react';
import PropTypes from 'prop-types';
// styles
import styled from 'styled-components';
// components
import { ButtonRound } from '@ontruck/orc';

const RemoveButton = ({ handleRemove, className }) => (
  <div className={`${className} deleteContainer`} data-testid="remove-button">
    <ButtonRound skin="primary" size="S" icon="close" onClick={handleRemove} />
  </div>
);

RemoveButton.propTypes = {
  handleRemove: PropTypes.func.isRequired,
};

export default styled(RemoveButton)``;
